import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { scroller } from 'react-scroll';
import { usePageTracking } from './utils/usePageTracking';
import Header from './components/Header';
import Hero from './components/sections/Hero';
import ImageProcessor from './components/sections/ImageProcessor';
import Pricing from './components/sections/Pricing';
import FAQ from './components/sections/FAQ';
import Gallery from './components/sections/Gallery';
import Footer from './components/sections/Footer';
import Success from './components/pages/Success';
import SessionCleanup from './components/SessionCleanup';
import './styles/global.css';

// Create a TrackedApp component to use the hook
function TrackedApp() {
  usePageTracking(); // This will track all page views
  const location = useLocation();

  const scrollToSection = (hash) => {
    const section = hash.replace('#', '');
    scroller.scrollTo(section, {
      duration: 800,
      smooth: true,
      offset: -80
    });
  };

  useEffect(() => {
    // Handle both initial load and navigation
    if (location.hash && location.pathname === '/') {
      // For initial page load, need a longer delay
      const timeoutId = setTimeout(() => {
        scrollToSection(location.hash);
      }, 500); // Longer delay for initial load

      return () => clearTimeout(timeoutId);
    }
  }, []); // Empty dependency array for initial load

  useEffect(() => {
    // Handle navigation changes
    if (location.hash && location.pathname === '/') {
      scrollToSection(location.hash);
    }
  }, [location]); // Re-run when location changes

  return (
    <div className="App">
      <SessionCleanup />
      <Routes>
        <Route path="/" element={
          <>
            <Header />
            <Hero />
            <ImageProcessor />
            <Pricing />
            <FAQ />
            <Gallery />
            <Footer />
          </>
        } />
        <Route path="/success" element={<Success />} />
      </Routes>
    </div>
  );
}

// Main App component
function App() {
  return (
    <Router>
      <TrackedApp />
    </Router>
  );
}

export default App; 
